(function () {
	'use strict';

	angular
		.module('sodCommon')
		.directive('myMaxlength', myMaxlength);

	function myMaxlength() {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elem, attrs, ctrl) {
				var maxLength = Number(attrs.myMaxlength);
				ctrl.$parsers.push(function fromInput(text) {
					if (text.length > maxLength) {
						var transformedInput = text.substring(0, maxLength);
						ctrl.$setViewValue(transformedInput);
						ctrl.$render();
						return transformedInput;
					}
				});
			}
		};
	}
})();